import React, { Component } from "react";
import languagePicker, {
  textsPicker,
  themeDirectionPicker,
} from "./languages/languages";
import Generator from "./routes/generator";
import Landing from "./routes/landing";
import { Route, Switch } from "react-router-dom";
import Encyclopedia from "./routes/encyclopedia";
import RugsPreview from "./components/rug/rugsPreview";
import EncyclopediaPost from "./routes/encyclopediaPost";
import Insurance from "./routes/insurance";
import RoomLayout from "./routes/room";
import { Helmet } from "react-helmet";

class App extends Component {
  constructor(props) {
    super(props);
    // Get data required to render the page according to user language
    const { texts, language, themeDirection } = languagePicker(
      window.location.search
    );
    this.state = {
      isAuthenticated: true,
      texts: texts,
      language: language,
      themeDirection: themeDirection,
    };
  }

  handleLangSwitch = (lang) => {
    // const texts = textsPicker(lang);
    // const direction = themeDirectionPicker(lang);
    const { texts, language, themeDirection } = languagePicker(null, lang);
    console.log(language);
    this.setState({
      texts: texts,
      themeDirection: themeDirection,
      language: language,
    });
  };

  render() {
    return (
      <>
        {this.state.themeDirection === "ltr" && (
          <Helmet>
            <link rel="stylesheet" href="/static/css/ltr-style.min.css" />
          </Helmet>
        )}
        <Switch>
          <Route
            exact
            path={"/"}
            render={(props) => (
              <Generator
                texts={this.state.texts}
                globalState={this.state}
                langHandler={this.handleLangSwitch}
              />
              // <Landing
              //   globalState={this.state}
              //   langHandler={this.handleLangSwitch}
              //   {...props}
              //   texts={this.state.texts}
              // />
            )}
          />
          <Route
            exact
            path={"/generator"}
            render={() => (
              <Generator
                texts={this.state.texts}
                globalState={this.state}
                langHandler={this.handleLangSwitch}
              />
            )}
          />
          <Route
            exact
            path={"/wiki"}
            render={() => (
              <Encyclopedia
                texts={this.state.texts}
                globalState={this.state}
                langHandler={this.handleLangSwitch}
              />
            )}
          />
          <Route
            exact
            path={"/wiki/:postID"}
            render={(context, match) => (
              <EncyclopediaPost
                texts={this.state.texts}
                context={context}
                match={match}
              />
            )}
          />
          <Route
            exact
            path={"/preview"}
            render={(context) => (
              <RugsPreview
                texts={this.state.texts}
                context={context}
                globalState={this.state}
                langHandler={this.handleLangSwitch}
              />
            )}
          />
          <Route
            exact
            path={"/insurance"}
            render={(context) => (
              <Insurance
                texts={this.state.texts}
                context={context}
                globalState={this.state}
                langHandler={this.handleLangSwitch}
              />
            )}
          />
          <Route
            exact
            path={"/room"}
            render={(context) => (
              <RoomLayout
                texts={this.state.texts}
                context={context}
                globalState={this.state}
                langHandler={this.handleLangSwitch}
              />
            )}
          />
          {/* <Route exact path={'/reset/:key'} render={({ match }) => <ResetPassword texts={this.state.texts} match={match} />} /> */}
          <Route
            exact
            path={"/test"}
            render={(props) => (
              <Landing
                globalState={this.state}
                langHandler={this.handleLangSwitch}
                {...props}
                texts={this.state.texts}
              />
            )}
          />
        </Switch>
      </>
    );
  }
}

export default App;
